import styled from 'styled-components/native';

export const Poster = styled.ImageBackground`
  width: 100%;
  height: 100%;
`;

export const ViewImage = styled.View`
  flex: 3;
  align-items: center;
  justify-content: flex-end;
`;

export const Image = styled.Image`
  width: 55%;
  height: 85%;
`;

export const ViewTitle = styled.View`
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.View`
  flex: 5;
  justify-content: flex-start;
  padding: 1rem 3rem;
`;

export const ViewTextInput = styled.View`
  height: 5rem;
`;

export const ViewText = styled.View`
  height: 80%;
`;

export const ViewHelper = styled.View`
  height: 20%;
  justify-content: center;
`;

export const ViewButton = styled.View`
  padding: 1rem 0rem;
  justify-content:center;
  align-items: center;
`;